import React from 'react';
import logo from './img/CCOREWhite.png';


function Header() {
    return <img src={logo} alt="Logo" height = "60px" />;
    
}

export default Header;